module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_co_cats_real_estate_8282b70c1d36a1c62165d144eb1903eb.png";